import { AxiosResponse } from 'axios';
import config from 'config';
import { CodelistsPayload, ListCodelistsParams, UnLocodeExtendedPayload } from './code';
import { DeclarationTypes } from 'store/declarations/enums/common/declaration-types';
import axiosClient from '../../config/axios';
import { ListPayload, SuccessResponse } from 'core/http/response';
import { SortDirections } from 'utils/tableHelpers';

export const getIrelandCodeLists = (type: DeclarationTypes | undefined): Promise<CodelistsPayload[]> =>
    axiosClient
        .get<{ ieCodeLists: CodelistsPayload[] }>(`${config.cmsUrl}/codelist/iecodelists?type=${type}`)
        .then((response) => response.data.ieCodeLists);

export const getUkCodeLists = (type: DeclarationTypes | undefined): Promise<CodelistsPayload[]> =>
    axiosClient
        .get<{ ukCodeListsList: CodelistsPayload[] }>(`${config.cmsUrl}/codelist/ukcodelists?type=${type}`)
        .then((response) => response.data.ukCodeListsList);

export const listEuCodelists = async (
    params: ListCodelistsParams & {
        query?: string;
        countryCode?: string;
    }
): Promise<ListPayload<CodelistsPayload>> => {
    const response: AxiosResponse<SuccessResponse<ListPayload<CodelistsPayload>>> = await axiosClient.get(
        `${config.cmsUrl}/codelist/eucodelists/list`,
        {
            params,
        }
    );
    return response.data.payload;
};

export const listUnLocodeExtended = async (params: {
    query?: string;
    countryCode?: string;
    page: number;
    size: number;
}): Promise<UnLocodeExtendedPayload> => {
    const response: AxiosResponse<SuccessResponse<UnLocodeExtendedPayload>> = await axiosClient.get(
        `${config.cmsUrl}/codelist/eucodelists/unlocode-extended`,
        { params }
    );
    return response.data.payload;
};

export const getEuCodelist = async (
    type: DeclarationTypes,
    codelistName: string
): Promise<{
    euCodeLists: CodelistsPayload[];
}> => {
    const response: AxiosResponse<{
        euCodeLists: CodelistsPayload[];
    }> = await axiosClient.get(`${config.cmsUrl}/codelist/eucodelists/${type}/${codelistName}`);
    return response.data;
};

export const getIeUnLocodeExtendedCodelist = (
    customerId: string | undefined,
    pagination: { page: number; size: number }
): Promise<UnLocodeExtendedPayload> => {
    const params: ListCodelistsParams = {
        page: pagination.page,
        size: pagination.size,
        sortDirection: SortDirections.DESC,
        sort: 'ID',
        type: DeclarationTypes.NCTS,
        archived: false,
        codeListNames: ['UnLocodeExtended'],
        customerId: customerId,
    };
    return axiosClient
        .get<{ payload: UnLocodeExtendedPayload }>(`${config.cmsUrl}/codelist/iecodelists/list`, {
            params,
        })
        .then((response) => response.data.payload);
};

export const getUkUnLocodeExtendedCodelist = (
    customerId: string | undefined,
    pagination: { page: number; size: number }
): Promise<UnLocodeExtendedPayload> => {
    const params: ListCodelistsParams = {
        page: pagination.page,
        size: pagination.size,
        sortDirection: SortDirections.DESC,
        sort: 'ID',
        type: DeclarationTypes.NCTS,
        archived: false,
        codeListNames: ['UnLocodeExtended'],
        customerId: customerId,
    };
    return axiosClient
        .get<{ payload: UnLocodeExtendedPayload }>(`${config.cmsUrl}/codelist/ukcodelists/list`, {
            params,
        })
        .then((response) => response.data.payload);
};

export const createIrelandCodeLists = (data: {}): Promise<any> =>
    axiosClient.post(`${config.cmsUrl}/codelist/iecodelists/create`, data);

export const createUkCodeLists = (data: {}): Promise<any> =>
    axiosClient.post(`${config.cmsUrl}/codelist/ukcodelists/create`, data);

export const deleteIrelandCodeLists = (codelistId: string): Promise<any> =>
    axiosClient.delete(`${config.cmsUrl}/codelist/iecodelists/delete/${codelistId}`);

export const deleteUkCodeLists = (codelistId: string): Promise<any> =>
    axiosClient.delete(`${config.cmsUrl}/codelist/ukcodelists/delete/${codelistId}`);

export const updateIrelandCodeLists = (data: { id: string }): Promise<any> =>
    axiosClient.put(`${config.cmsUrl}/codelist/iecodelists/update/${data.id}`, data);

export const updateUkCodeLists = (data: { id: string }): Promise<any> =>
    axiosClient.put(`${config.cmsUrl}/codelist/ukcodelists/update/${data.id}`, data);
